/* eslint-disable camelcase */
import axios from 'axios';
import {
  MENU_ENDPOINT,
  MENUPRODUCT_ENDPOINT,
  MENUSECTION_ENDPOINT
} from '@menu/constants';

// Menu structure
export const menuRequest = (menu__guid) => axios.get(MENU_ENDPOINT(menu__guid));

// Menu models
export const sectionRequest = (section__guid, menu__guid, type) => axios.get(
  MENUSECTION_ENDPOINT(section__guid), { params: { menu__guid, type } }
);
export const createSectionRequest = (section) => axios.post(MENUSECTION_ENDPOINT(), section);
export const editSectionRequest = (section__guid, section) => axios.put(MENUSECTION_ENDPOINT(section__guid), section);
export const deleteSectionRequest = (section__guid) => axios.delete(MENUSECTION_ENDPOINT(section__guid));

export const createProductRequest = (product) => axios.post(MENUPRODUCT_ENDPOINT(), product);
export const editProductRequest = (product__guid, product) => axios.put(MENUPRODUCT_ENDPOINT(product__guid), product);
export const deleteProductRequest = (product__guid) => axios.delete(MENUPRODUCT_ENDPOINT(product__guid));
